import React from "react";
import "./ContactPage.css";

const ContactPage = () => {
  return (
    <div className="contact-root">
      <h1 className="contact-title">Contact Page</h1>
      <p className="contact-description">Contact Page Placeholder</p>
    </div>
  );
};

export default ContactPage;
